import { render, staticRenderFns } from "./column.vue?vue&type=template&id=092dcbc6"
import script from "./column.vue?vue&type=script&lang=js"
export * from "./column.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('092dcbc6')) {
      api.createRecord('092dcbc6', component.options)
    } else {
      api.reload('092dcbc6', component.options)
    }
    module.hot.accept("./column.vue?vue&type=template&id=092dcbc6", function () {
      api.rerender('092dcbc6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/import/general/column.vue"
export default component.exports